
import {
    LAWYERS
  } from '../constants/types';

  export default function(state=[], action){
    switch(action.type){
      case LAWYERS:
        return action.payload
      default:
        return state
    }
  }
